// The read-only banner (M11, decision 17): from 7 days before an unpaid company goes read-only, and
// while it is, on every screen. The owner gets a button to the subscription; everyone else is told
// to ask them. Read once a page load and again every ten minutes.

import { useEffect, useState } from 'react';
import { bannerFor, type BillingState } from './account-model.ts';
import './account.css';

let loaded: { at: number; state: Promise<BillingState | null> } | null = null;
function billingState(): Promise<BillingState | null> {
  if (!loaded || Date.now() - loaded.at > 600_000)
    loaded = {
      at: Date.now(),
      state: fetch('/billing/state', { credentials: 'same-origin' })
        .then((r) => (r.ok ? (r.json() as Promise<{ ok: boolean; result: BillingState }>) : null))
        .then((b) => (b?.ok ? b.result : null))
        .catch(() => null),
    };
  return loaded.state;
}

export function AccountBanner({ onPay }: { onPay: () => void }) {
  const [state, setState] = useState<BillingState | null>(null);
  useEffect(() => {
    let live = true;
    void billingState().then((s) => live && setState(s));
    return () => {
      live = false;
    };
  }, []);
  const b = bannerFor(state, new Date(), Intl.DateTimeFormat().resolvedOptions().timeZone);
  if (!b) return null;
  return (
    <div className={`account-banner ${b.tone}`} role={b.tone === 'bad' ? 'alert' : 'status'}>
      <p>{b.text}</p>
      {b.action && (
        <button className="btn primary" onClick={onPay}>
          {b.action}
        </button>
      )}
    </div>
  );
}
